import { createActionGroup, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import { StockCountHistoryListContent, StockCountHistorySearchCriteria } from '../../model/stock-count-history.model';

export const StockCountHistoryAction = createActionGroup({
  source: 'Stock Count History',
  events: {
    RequestList: props<{ criteriaObj: StockCountHistorySearchCriteria }>(),
    ResponseList: props<{
      data: Pagination<StockCountHistoryListContent>;
    }>()
  }
});
